import { ROUTE_PATHS } from '@/shared/config/router/types';

export const TWO_DAYS_IN_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
export const NEW_GAMES_INDICATOR_TIMER = 'new_games_indicator_timer';

export const MAX_PATH_DEPTH_TO_SHOW_NAVBAR = 2;

export const RELATIVE_PATHNAMES = Object.values(ROUTE_PATHS).filter(
  (path) => !path.startsWith('/')
);

export const FULL_SCREEN_PAGES = [
  ROUTE_PATHS.CLICKER,
  ROUTE_PATHS.PRIZE,
  ROUTE_PATHS.LOOTBOX,
];

export const BOINKER_VISITED_KEY = 'boinker_visited';
